//basic
import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import '../parameters/Parameters.scss';

//api
import { api } from '../../functions/api';

//custom components
// import CustomTable from '../../components/complex/customTable';
import CustomTable2 from '../../components/complex/customTable2';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import AddEditParameter from './AddEdit/AddEditParameter';
import ChangeValues from './ChangeValues/ChangeValues';
import DeleteDialog from '../../components/global/deleteDialog';

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react'
import { mdiPlus} from '@mdi/js'



@inject('internal')
@inject('translate')
@observer
export default class Parameters extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: false,
            addEditDialog: false,
            changeParameterValues: false,
            idParam: null, //pouziva sa pre upravovanie hodnot parametra
        }
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    componentDidMount () {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameters && user.data.permissions.lists_parameters.view) {
            this.setPermissions()
            this.loadParameters()
            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.PARAMETERS);
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    setPermissions () {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameters && user.data.permissions.lists_parameters) {
            if(user.data.permissions.lists_parameters.update) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
                        action: "edit"
                    },
                )
            }

            if(user.data.permissions.lists_parameters.destroy) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                        action: "delete"
                    }
                )
            }
        }
    }

    loadParameters = async (size = 10, page = 0, searchterm = "", by = "internal_name", dir = "asc") => {

        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let load_data = await api({
            method:'get',
            url: 'lists/parameters',
            authorization: this.props.internal.user.access_token,
            params:{
                searchterm: searchterm,
                page:{
                    number:page,
                    size:size,
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ]
            }
        })

        if (load_data.success === true) {
        // if (load_data.success !== true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
        
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadParameters()
    }

    tableHeader = [
        {
            "title": "title_frontend",
            "numeric": false,
            sortBy: "external_name",
            "min_width": "125px",
            editable: true
        },
        {
            "title": "title_backend",
            "numeric": false,
            "min_width": "125px"
        },
        {
            "title": "parameter_type",
            "numeric": false,
        },
        {
            "title": "items_count",
            "numeric": true
        },
        {
            "title": "action",
            "numeric": false,
            textAlign: "center"
        },
        {
            "title": "production",
            "numeric": false,
            textAlign: "center"
        },
    ];
    // tableBody = [
    //     "name",
    //     "name",
    //     "id",
    //     "id",
    //     "id"
    // ];
    tableBody = [
        {
            title: "external_name",
            // editable: true
        },
        {
            title: "internal_name",
        },
        {
            title: "parameter_type_id",
            textAlign: "left"
        },
        {
            title: "items_count",
        },
        {
            title: "action",
            textAlign: "center"
        },
        {
            title: "production",
            textAlign: "center"
        },
    ];

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // }
    ];

    //dialog pre vytvorenie/upravenie parametra
    handleOpenCloseDialog = () => {
        const { user } = toJS(this.props.internal)
        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameters && user.data.permissions.lists_parameters.update) {
            let actionEdit = toJS(this.props.internal.actionEdit)
            if(actionEdit.edit) {
                actionEdit = {
                    edit: false,
                    id: null
                }
                this.props.internal.setActionEdit(actionEdit)
            }
            else {
                this.setState({addEditDialog: !this.state.addEditDialog})
            }
            this.loadParameters()
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    changeParameterValues = (id) => {
        const { user } = toJS(this.props.internal)
        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.view) {
            this.setState({changeParameterValues: !this.state.changeParameterValues, idParam: id})
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
        //reload
        if(id === true) {
            this.loadParameters()
        }
    }

    handleDelete = async() => {
        let id = toJS(this.props.internal.actionDeleteObj.id)
        let delete_data = await api({
            method:'delete',
            url: `lists/parameters/${id}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true);
            this.props.internal.setActionDelete();
        }
        else {
            this.props.internal.setSnackbar(delete_data.data.message, true);
        }
        this.loadParameters()
    }

    clickOnProductionStatus = async(id, status) => {
        const { user } = toJS(this.props.internal)
        if(user && user.data && user.data.permissions && user.data.permissions.lists_parameters && user.data.permissions.lists_parameters.update) {

            let update_data = await api({
                method:'patch',
                url: `lists/parameters/${id}`,
                authorization: this.props.internal.user.access_token,
                params:{
                    production: status
                }
            })

            if(update_data.success === true) {
                this.props.internal.setSnackbar(update_data.data.message, true);
                this.loadParameters();
            }
            else {
                this.props.internal.setSnackbar(update_data.data.message, true);
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    render() {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'} />
                :
                <div className={'parameters'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.PARAMETERS.DELETE_PARAMETER_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {/* dialog pre upravovanie/vytvorenie parametru */}
                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEditParameter
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES.PARAMETERS.CREATE_NEW_PARAMETER_TITLE :this.props.translate.i18n.MODULES.PARAMETERS.EDIT_PARAMETER_TITLE}
                        />
                    }

                    {/* dialog pre upravovanie hodnot vybraneho parametru */}
                    {this.state.changeParameterValues &&
                        <ChangeValues
                            open={this.state.changeParameterValues}
                            onClose={this.changeParameterValues}
                            title={this.props.translate.i18n.MODULES.PARAMETERS.EDIT_PARAMETER_VALUES}
                            id={this.state.idParam}
                        />
                    }
                    
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.PARAMETERS.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {user && user.data  && user.data.permissions && user.data.permissions.lists_parameters && user.data.permissions.lists_parameters.store ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES.PARAMETERS.CREATE_NEW_PARAMETER}
                                onClick = {this.handleOpenCloseDialog}
                            >
                                    <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                
                {this.state.loadingTable ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    <CustomTable2
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/parameters'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                        changeParameterValues={this.changeParameterValues}
                        clickOnProductionStatus={this.clickOnProductionStatus}
                    />
                    }
                </div>
               
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/parameters/Parameters.js